import { ProgressBar } from 'baseui/progress-bar';
import { Normal5, Tiny2 } from 'components/Typography';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { appConfig } from 'utils/app.config';
import { getStaticAssetUrl } from 'utils/url';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DashboardCategory = ({
  quests,
  title,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  quests: any[];
  title: string;
}) => {
  const { t } = useTranslation('dashboard');
  const [svgContents, setSvgContents] = useState<(string | undefined)[]>([]);

  const fetchSvg = async (url: string, status: string) => {
    const response = await fetch(url);
    if (response.ok) {
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'image/svg+xml');
      const svgElement = doc.querySelector('svg');
      if (svgElement) {
        const elements = svgElement.querySelectorAll('*[fill="#F5F5F5"]');
        if (status == 'completed') {
          elements.forEach((el) => {
            el.setAttribute('fill', '#9DB178');
          });
        }
      }
      const modifiedSvg = new XMLSerializer().serializeToString(doc);
      return modifiedSvg;
    }
  };

  useEffect(() => {
    const fetchAllSvgs = async () => {
      const fetchedSvgs = await Promise.all(
        quests.map((quest) => {
          if (!quest.imageUrl) return null;
          return fetchSvg(
            appConfig.staticAssetsHost + quest.imageUrl,
            quest.status
          );
        })
      );
      setSvgContents(fetchedSvgs.map((x) => x ?? undefined));
    };
    fetchAllSvgs();
  }, [quests]);

  return (
    <div
      className={`${title == 'get-started' && 'hidden'} px-4 pt-10 lg:px-0 lg:pt-16`}
    >
      <Normal5 className='pb-1 text-base font-bold capitalize text-white-200 lg:pb-4'>
        {title == 'todays-mission' && 'Past missions'}{' '}
      </Normal5>
      <div className='-mx-3 pb-6'>
        <ProgressBar
          value={0}
          overrides={{
            BarProgress: {
              style: () => ({
                backgroundColor: '#AAE2FF',
                borderTopLeftRadius: '100px',
                borderTopRightRadius: '100px',
                borderBottomLeftRadius: '100px',
                borderBottomRightRadius: '100px',
              }),
            },
            Bar: {
              style: () => ({
                height: '8px',
                borderTopLeftRadius: '100px',
                borderTopRightRadius: '100px',
                borderBottomLeftRadius: '100px',
                borderBottomRightRadius: '100px',
                backgroundColor: '#1B1D1E',
              }),
            },
          }}
        />
      </div>
      <div className='grid grid-cols-1 gap-4 pt-8 md:gap-5 lg:grid-cols-3 lg:gap-14'>
        {quests?.map((item, index) => (
          <Link
            href={item?.redirectUrl || '#'}
            key={index}
            target='_blank'
            className={`group flex border-[0.5px] ${item.status == 'completed' ? 'border-positive-800' : 'border-mono-100'} pointer-events-none transition-all duration-500 ease-in-out`}
          >
            {svgContents[index] && (
              <div
                className={`pointer-events-none  -ms-6 flex h-[124px] min-h-[178px] w-[94px] items-center border-e-[0.5px] opacity-50 ${item.status == 'completed' ? 'border-positive-800' : 'border-mono-100'} ${item.status == 'completed' ? `bg-[url(${getStaticAssetUrl('/sfi/static/dashboard/taskPlaceholderGreen.svg')}]` : `bg-[url(${getStaticAssetUrl('/sfi/static/dashboard/taskPlaceholder.svg')}]`} object-contain`}
                dangerouslySetInnerHTML={{ __html: svgContents[index] }}
              />
            )}

            <div
              className={`flex w-full flex-col justify-between border-[0.5px] ${item.status == 'completed' ? 'border-positive-800' : 'border-mono-100'} p-3 group-hover:bg-transparent   md:p-5`}
            >
              <div>
                <Normal5
                  className={`pointer-events-none pb-3 text-white-200 opacity-50 transition-colors  duration-300 ease-in-out md:text-base`}
                >
                  {item.title}
                </Normal5>
              </div>
              <Tiny2
                className={`text-right font-normal capitalize text-negative-800 transition-colors duration-300 ease-in-out`}
              >
                {t('ENDED')}
              </Tiny2>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
